
/**
 * Internal dependencies
 */
import {
    ROAM_PLANS_RECEIVE,
    ROAM_PLANS_REQUEST,
    ROAM_PLANS_REQUEST_SUCCESS,
    ROAM_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllRoamPlans, requestingRoamPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestRoamPlans = () => (dispatch) => {
    dispatch({
        type: ROAM_PLANS_REQUEST
    });
    return cscom
        .roamPlan()
        .list()
        .then(roamPlans => {
            dispatch({ type: ROAM_PLANS_REQUEST_SUCCESS });
            dispatch({ type: ROAM_PLANS_RECEIVE, payload: { items: roamPlans } });
            return roamPlans;
        })
        .catch((error) => {
            dispatch({ type: ROAM_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllRoamPlans(getState());
	const requesting = requestingRoamPlans(getState());

	if (plans.length == 0 && requesting == false) {
		return dispatch(requestRoamPlans(...props))
	}

	return plans;
}